export async function resizeImage(
  dataUrl: string,
  widthMax: number,
  heightMax: number,
  quality = 0.8
): Promise<string> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = dataUrl;
    img.onerror = () => reject(new Error('Image invalide ou illisible'));
    img.onload = () => {
      const originalWidth = img.width;
      const originalHeight = img.height;
      const aspectRatio = originalWidth / originalHeight;

      let newWidth = originalWidth;
      let newHeight = originalHeight;

      if (originalWidth > widthMax || originalHeight > heightMax) {
        if (originalWidth / widthMax > originalHeight / heightMax) {
          newWidth = widthMax;
          newHeight = widthMax / aspectRatio;
        } else {
          newHeight = heightMax;
          newWidth = heightMax * aspectRatio;
        }
      }

      const canvas = document.createElement('canvas');
      canvas.width = newWidth;
      canvas.height = newHeight;
      const ctx = canvas.getContext('2d') as CanvasRenderingContext2D;

      ctx.drawImage(img, 0, 0, newWidth, newHeight);

      resolve(canvas.toDataURL('image/jpeg', quality));
    };
  });
}
